import styled from 'styled-components';
import UploadIcon from '~/assets/button/upload.png';
import AllImagesIcon from '~/assets/button/all_images.png';
import AllVideosIcon from '~/assets/button/all_videos.png';
import UnsplashIcon from '~/assets/button/unsplash.png';
import PexelsIcon from '~/assets/button/pexels.png';
import LibraryIcon from '~/assets/button/library.png';
import AiIcon from '~/assets/button/ai_b.png';

const Wrapper = styled.div`
  flex: 1;
  display: flex;

  .closeBtn {
    margin-left: calc(100% - 70px);
    margin-top: -13px;
  }

  .left {
    width: 250px;
    padding-right: 20px;

    h3 {
      font-family: ralewayBold;
      font-size: 14px;
      font-weight: unset !important;
      line-height: 16.44px;
      letter-spacing: 0.1em;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }

    ul {
      margin-top: 20px;
      li {
        padding: 8px;
        font-family: Raleway;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        cursor: pointer;

        display: flex;
        justify-content: space-between;
        padding-left: 36px;

        svg {
          rotate: 180deg;
          margin-top: 5px;
          path {
            fill: #e0e0e0;
          }
        }
      }
      li.active {
        border-radius: 8px;
        background: #f5f5f5;

        svg {
          path {
            fill: #000;
          }
        }
      }
      li.all_images {
        background-image: url(${AllImagesIcon});
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: 10px center;
      }
      li.all_videos {
        background-image: url(${AllVideosIcon});
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: 10px center;
      }
      li.upload {
        background-image: url(${UploadIcon});
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: 10px center;
      }
      li.unsplash {
        background-image: url(${UnsplashIcon});
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: 10px center;
      }
      li.pexels {
        background-image: url(${PexelsIcon});
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: 10px center;
      }
      li.ai {
        background-image: url(${AiIcon});
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: 10px center;
      }
      li.easyllama {
        background-image: url(${LibraryIcon});
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: 10px center;
      }
    }
  }
  .right {
    h3 {
      font-family: ralewayBold;
      font-size: 16px;
      font-weight: unset !important;
      line-height: 24px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      padding-bottom: 10px;
    }
    .header {
      border-bottom: 1px solid #d9d9d9;
      margin-bottom: 10px;
      padding-bottom: 20px;
      display: flex;
      flex-direction: row;

      button {
        background: #9738ff;
        color: #fff;
        cursor: pointer;
      }

      input[type='text'] {
        width: 100%;
        padding: 10px;
        border: 1px solid #d9d9d9;
        border-radius: 5px;
        background-color: #f5f5f5;
        color: #6f6f6f;
        font-family: Raleway;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
      }

      p {
        padding-left: 20px;

        font-family: Raleway;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: #6f6f6f;
      }
    }
    .header.upload {
      display: flex;
      flex-direction: row;

      align-items: center;

      background: #f8f1ff;
      border-radius: 10px;
      padding: 16px;
      border: 1px dashed #9738ff;

      button {
        background: transparent;
        border: 2px solid #9738ff;
        color: #9738ff;
        border-radius: 8px;
        height: 38px;
        cursor: pointer;
      }

      .text {
        flex: 1;
        padding-left: 10px;

        b {
          font-family: Raleway;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0%;
          color: #000000;
        }

        p {
          padding-left: 0px;
          font-family: Raleway;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0%;
          color: #6f6f6f;
        }
      }
    }

    .header.ai {
      display: flex;
      flex-direction: row;
      gap: 10px;

      input {
        width: 100%;
        background-image: url(${AiIcon});
        background-size: 20px;
        background-repeat: no-repeat;
        background-position: 10px center;
        padding-left: 40px;
      }

      select {
        padding: 10px;
        border: 1px solid #d9d9d9;
        border-radius: 5px;
        background-color: #f5f5f5;
        color: #6f6f6f;
        font-family: Raleway;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
      }

      button {
        background: #9738ff;
        color: #fff;
        cursor: pointer;
        white-space: nowrap;
        min-width: 200px;
      }
    }
    .no_results {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      justify-content: center;
      flex: 1;
      height: 330px;
      width: 840px;

      p {
        font-family: Raleway;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0%;
        text-align: center;
        color: #2e2e2e;
      }
    }
    .images {
      display: flex;
      gap: 5px;
      flex-wrap: wrap;
      overflow-y: auto;
      max-height: 330px;
      width: 840px;

      .weNeedToLoad {
        height: 1px;
        width: 100%;
        visibility: hidden;
      }

      .image-item > img {
        width: 268.69px;
        height: 162.7px;
        cursor: pointer;
        border: 1px solid transparent;
        border-radius: 5.47px;
        opacity: 0;
        transform: translateY(6px);
        transition:
          opacity 180ms ease-out,
          transform 180ms ease-out;
      }

      .image-item > img.loaded {
        opacity: 1;
        transform: translateY(0);
      }

      .image-item > img:hover {
        filter: brightness(0.8);
        cursor: pointer;
      }

      .selected {
        border: 1px solid #9738ff;
      }
    }
    .images.small {
      max-height: 270px;
    }
    .images.long {
      max-height: 430px;
    }

    .images.loading {
      min-height: 330px;
    }

    .document-name {
      font-family: ralewayBold;
      font-weight: unset !important;
      font-size: 12px;
      line-height: 150%;
      letter-spacing: 0%;
      font-variant-numeric-figure: lining-nums;
      font-variant-numeric-spacing: proportional-nums;
      color: #2e2e2e;
      width: 250px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .image-item {
      position: relative;
      width: 268.69px;
      height: 162.7px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .skeleton {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        border-radius: 5.47px;
        background: linear-gradient(
          90deg,
          #f2f2f2 0%,
          #e9e9e9 40%,
          #f2f2f2 80%
        );
        background-size: 200% 100%;
        animation: shimmer 1.2s linear infinite;
      }

      @keyframes shimmer {
        0% {
          background-position: 200% 0;
        }
        100% {
          background-position: -200% 0;
        }
      }

      > button {
        position: absolute;
        display: none;
        z-index: 1;
        background: #fff;
        border: none;
        cursor: pointer;
        border-radius: 8px;

        background-color: rgb(243, 236, 255);
        color: #9738ff;
        padding: 5px;
        top: 5px;
        right: 5px;
        margin: 0px;

        width: 28px;
        height: 28px;

        svg {
          path {
            fill: #9738ff;
          }
        }
      }

      p {
        display: none;
        position: absolute;
        bottom: 50%;
        width: 100%;
        text-align: center;
        margin: auto;
        color: #fff;
        font-family: Raleway;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
        text-underline-position: from-font;
        text-align: center;
        cursor: pointer;
      }

      &:hover > button {
        display: block;
      }

      &:hover p {
        display: block;
      }

      p:hover {
        filter: brightness(0.8);
        flex: 1;
      }

      p.processing {
        display: block;
        color: #999;
        cursor: default;
        font-size: 13px;

        &:hover {
          filter: none;
        }
      }

      .preview-button {
        position: absolute;
        margin-right: 35px;
      }

      .video-button {
        position: absolute;
        margin-right: 35px;
      }
    }
    .error-message {
      color: #000;
      background-color: #fff1f4;
      border: 1px solid #ff3868;
      padding: 5px;
      position: absolute;
      z-index: 10;

      width: 840px;
      margin-top: -6px;

      border-radius: 16px;
      padding-top: 10px;
      padding-right: 16px;
      padding-bottom: 10px;
      padding-left: 16px;

      font-family: Raleway;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0%;

      b {
        font-family: ralewayBold;
        font-weight: unset !important;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0%;
      }

      img {
        width: 30px;
      }
    }
  }
`;

export default Wrapper;
